import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import { uiState } from 'react-redux-ui-state';
import VerifiedUser from '@material-ui/icons/VerifiedUser';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';

import ORTable from 'components/ORTable/ORTable';
import ORTypography from 'components/ORTypography/ORTypography';
import OrgImpersonationForm from './OrgImpersonationForm/OrgImpersonationFormContainer';

const propTypes = {
  classes: PropTypes.shape({}).isRequired,
  impersonateOrg: PropTypes.func.isRequired,
  stopOrgImpersonation: PropTypes.func.isRequired,
  getOrg: PropTypes.func.isRequired,
  user: PropTypes.shape({
    impersonatedOrganizationId: PropTypes.string,
    orgSearchList: PropTypes.shape({
      list: PropTypes.arrayOf(PropTypes.shape({})),
    }),
  }).isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  setUiState: PropTypes.func.isRequired,
};

export function UnstyledOrgImpersonationPage({
  classes,
  impersonateOrg,
  stopOrgImpersonation,
  getOrg,
  user,
  page,
  rowsPerPage,
  setUiState,
}) {
  function handleChangePage(event, newPage) {
    setUiState({
      page: newPage,
    });
  }

  const { list: orgSearchList } = user.orgSearchList;
  const orgSelected = (id) => id === user.impersonatedOrganizationId;
  const orgActionButton = (orgId) => {
    return orgSelected(orgId) ? (
      <IconButton onClick={() => stopOrgImpersonation()}>
        <Icon classes={{ root: classes.cancelButton }} fontSize="large">
          face
        </Icon>
      </IconButton>
    ) : (
      <IconButton
        onClick={() => {
          impersonateOrg(orgId);
          getOrg();
        }}
      >
        <Icon classes={{ root: classes.impersonateButton }} fontSize="large">
          face
        </Icon>
      </IconButton>
    );
  };

  const orgList =
    orgSearchList.length !== 0 &&
    orgSearchList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((thisOrg) => (
      <TableRow key={thisOrg.id.toString()}>
        <TableCell className={classes.orgCell}>
          <div className={classes.orgDataContainer}>
            {thisOrg.companyName}
            <br />
            {thisOrg.id}
            <br />
            {thisOrg.primaryEmail}
            <br />
            {thisOrg.phoneNumber}
          </div>
          <div className={classes.impersonateButtonContainer}>{orgActionButton(thisOrg.id)}</div>
        </TableCell>
      </TableRow>
    ));

  return (
    <div className={classes.orgImpersonationContainer}>
      <div className={classes.orgImpersonationArea}>
        <div className={classes.listContainer}>
          <VerifiedUser className={classes.tableIcon} />
          <ORTable
            count={orgSearchList.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
          >
            <TableHead>
              <ORTypography className={classes.tableTextContainer}>
                Organization Lookup
              </ORTypography>
              <TableRow>
                <TableCell>
                  <OrgImpersonationForm handleChangePage={handleChangePage} />
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody classes={{ root: classes.tableScroll }}>{orgList}</TableBody>
          </ORTable>
        </div>
      </div>
    </div>
  );
}

UnstyledOrgImpersonationPage.propTypes = propTypes;

const styles = (theme) => ({
  orgImpersonationContainer: {
    padding: '24px',
  },
  orgImpersonationArea: {
    borderRadius: '3px',
    padding: '20px 8px',
  },
  tableTextContainer: {
    display: 'flex',
    color: theme.customColors.black,
    marginLeft: '44px',
    paddingTop: theme.spacing(1),
    width: '100%',
  },
  listContainer: {
    display: 'flex',
    flexFlow: 'column wrap',
    position: 'relative',
    alignItems: 'center',
    minHeight: '800px',
  },
  tableIcon: {
    color: theme.customColors.white,
    backgroundColor: theme.customColors.darkPurple,
    position: 'absolute',
    top: '-12px',
    left: '-10px',
    height: '45px',
    width: '45px',
    padding: '5px',
    borderRadius: '10px',
    boxShadow: '0px 5px 5px 0px rgba(216,216,216,1)',
  },
  tableScroll: {
    overflowY: 'scroll',
    maxHeight: '600px',
    display: 'flex',
    flexFlow: 'column',
  },
  impersonateButton: {
    color: theme.customColors.orange,
  },
  cancelButton: {
    color: theme.customColors.teal,
  },
  orgCell: {
    display: 'flex',
    justifyContent: 'space-between',
    flexFlow: 'row nowrap',
  },
  orgDataContainer: {
    flexFlow: 'column nowrap',
    overflowWrap: 'break-word',
    wordBreak: 'break-all',
    flexShrink: 2,
    paddingRight: theme.spacing(2),
  },
  impersonateButtonContainer: {
    display: 'flex',
    alignItems: 'center',
  },
});

export const uiConfig = {
  name: 'orgImpersonationTable',
  state: () => ({
    page: 0,
    rowsPerPage: 10,
  }),
};

export default uiState(uiConfig)(withStyles(styles)(UnstyledOrgImpersonationPage));
